import Component from '../core/Component'

export default class Print extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()
        window.print()
    }

}